import * as React from 'react';

import { transparentImage } from '../globals';
import {
	ImageLoaderConfig,
	ImageLoaderResult,
	imageLoader,
} from '../helpers/imageLoader';

export function useImageLoader(
	images: ImageLoaderConfig[]
): ImageLoaderResult[] {
	const [imagesArray, setImagesArray] = React.useState(
		images.map((image) => {
			return {
				status: 'loading',
				src: image.placeholder ? image.placeholder : transparentImage,
			};
		})
	);

	React.useEffect(() => {
		images.forEach((image, index) => {
			imageLoader(image).then((imageState) => {
				setImagesArray((currentImages) => {
					const updatedImagesArray = [...currentImages];
					updatedImagesArray[index] = imageState;
					return updatedImagesArray;
				});
			});
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return imagesArray;
}

export default useImageLoader;
